<script lang="ts">
  // Mobile compose button (spec §3).
  import { t } from '$lib/i18n';
  import { store } from '$lib/store';
  import { tooltip } from '$lib/util/dom';
  import Icon from '../ui/Icon.svelte';
</script>

<button type="button" class="fab mobile-only" aria-label={t('compose')} use:tooltip onclick={() => store.openCompose()}><Icon name="pen" size={22} /></button>

<style>
  /* @css shell/Fab start */
  .fab {
    position: fixed;
    inset-inline-end: var(--space-5);
    bottom: calc(var(--tabbar-h) + var(--space-4) + env(safe-area-inset-bottom));
    width: 56px;
    height: 56px;
    border-radius: var(--radius-lg);
    background: var(--blue-500);
    color: var(--text-on-accent);
    display: none;
    place-items: center;
    box-shadow: var(--shadow-lg);
    z-index: var(--z-nav);
    transition: background var(--duration-fast) var(--ease-standard), transform var(--duration-fast) var(--ease-standard)
  }

  .fab:hover {
    background: var(--blue-600)
  }

  .fab:active {
    transform: scale(.95)
  }

  .mobile-only {
    display: none
  }

  @media (max-width:900px) {
  button.mobile-only {
      display: inline-grid
    }
  }

  @media (max-width:900px) {
  .fab.mobile-only {
      display: grid
    }
  }

  .fab {
    inset-inline-end: calc(var(--space-5) + max(env(safe-area-inset-left), env(safe-area-inset-right)))
  }
  /* @css shell/Fab end */
</style>
